// extracted by mini-css-extract-plugin
export default {"list":"style_list__CuAbn","active":"style_active__zye-1"};